import type { FaireProductEntity } from "../../entity_types/product";

export const p_27ahsmqjtu: FaireProductEntity = {
  token: "p_27ahsmqjtu",
  type: "product",
  name: "40 Pack Countertop Fudge Display",
  brandToken: "b_5021dx08mu",
  brandName: "Valley Fudge & Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/a327841d52513dd321b0f668cd4759ecc2ea2520b1c506bad581fd9b9c8d82d1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da574eba18b364778ccb7ce0d4983b8f120eb6983e9023e5cdc51fcaf4efbf7d.jpeg",
    "https://cdn.faire.com/fastly/8817ba7ce97896fc88c8f91ca3333c5d05259cbb2737916682d61963c8e2a79a.jpeg",
    "https://cdn.faire.com/fastly/a563db08b2850d329f3888db9a9f564186b411b01f38bb461ac1993ba1dc2e7b.jpeg",
    "https://cdn.faire.com/fastly/0d670a992f151700b1f36039793dcd64c142c474ae966e8aa990118cdc3ae9f0.jpeg",
    "https://cdn.faire.com/fastly/f3118c01a6c17fb672e0192bb0d18a3ccc77678734206fcf115ac5164092bf09.jpeg",
  ],
  priceDollars: 152.43,
  description:
    'The 40-pack countertop fudge display is a delightful presentation of delectable 4 ounce fudge varieties. With 10 different flavors to choose from, it offers a diverse range of options to satisfy any sweet tooth. Each fudge piece is crafted with care, ensuring exceptional quality and flavor in every bite.  \n\nThe display holds 20 (4 oz.) pieces perfectly with 20 extra pieces for restocking! The display is 14" long, 10" wide and 8.5" tall. \n\nIncludes our top 10 selling flavors:\n\n6 of Chocolate (UPC 810105541434)\n6 of Chocolate Walnut (UPC 810105541441)\n4 of Mint Chocolate Swirl (UPC 810105541472)\n4 of Raspberry Chocolate Swirl (UPC 810105541458)\n4 of Peanut Butter Chocolate (UPC 810105541465)\n4 of Dark Chocolate Caramel Sea Salt (UPC 810105541489)\n3 of Caramel Vanilla Swirl (UPC 810105541496)\n3 of Maple Walnut (UPC 810105541502)\n3 of Butter Pecan (UPC 810105541519)\n3 of Birthday Cake (UPC 810105541762)        \n\nSale Shelf Life: We make all fudge fresh to order and ship it upon packaging. This provides 7-8 weeks of sale shelf life for your company. \n\nMerchandising Your Fudge: Your fudge is best merchandised at room temperature and out of direct sunlight. ',
  tags: [],
  msrpDollars: 277.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:30.477Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
